import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("aaf_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const mediaSrc = (m) => {
  if (!m?.src) return m?.external_url || "";
  return m.src.startsWith("/") ? `${process.env.REACT_APP_BACKEND_URL}${m.src}` : m.src;
};

export const thumbSrc = (m) =>
  m.thumbnail_url || (m.kind === "photo" ? mediaSrc(m) : null);

// Upload in 5MB parts so large files (videos, high-res photos) never exceed
// the ingress request-body limit — single-shot uploads fail for big files in
// production. Returns the created media document.
const CHUNK_SIZE = 5 * 1024 * 1024;

export async function uploadFileChunked(file, meta = {}, onProgress = () => {}) {
  const { data: init } = await api.post("/media/upload/init", {
    filename: file.name,
    title: meta.title ?? "Untitled",
    category: meta.category ?? "Portraits",
    location: meta.location ?? "",
    specs: meta.specs ?? "",
    room_id: meta.room_id ?? "",
  });
  const uploadId = init.upload_id;
  const total = file.size || 1;
  let sent = 0;
  for (let start = 0; start < file.size; start += CHUNK_SIZE) {
    const blob = file.slice(start, Math.min(start + CHUNK_SIZE, file.size));
    await api.put(`/media/upload/chunk/${uploadId}`, blob, {
      timeout: 0,
      headers: { "Content-Type": "application/octet-stream" },
      onUploadProgress: (e) => onProgress(Math.round(((sent + e.loaded) * 100) / total)),
    });
    sent += blob.size;
    onProgress(Math.round((sent * 100) / total));
  }
  const { data } = await api.post(`/media/upload/complete/${uploadId}`, {}, { timeout: 0 });
  return data;
}

export default api;
